import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient, useMutation } from 'react-query';
import HeadOfHouse from '../../../../../components/ui/HeadOfHouse/HeadOfHouse';
import ChangeHeadOfHouseModal from '../../../../../components/ui/modals/ChangeHeadOfHouseModal/ChangeHeadOfHouseModal';
import useHouseHead from '../../../../../queries/useHouseHead';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import { getQueryKeys } from '../../../../../queries/queryKeys';
import { getTenantOptions } from '../utils/getTenantOptions';
import changeHeadOfHouse from '../../../../../requests/changeHeadOfHouse';

const HouseHead = () => {
  const params = useParams();

  const queryClient = useQueryClient();

  const houseId = Number(params.pageId);

  const { visible, showModal, hideModal } = useChangeModalVisible();

  const { data: houseHead, isFetching: isHouseHeadFetching } = useHouseHead(
    houseId,
    { staleTime: Infinity }
  );

  const changeHeadOfHouseMutation = useMutation(
    ({ houseId, values, addType }) =>
      changeHeadOfHouse(houseId, values, addType),
    {
      onSuccess: (_data, { houseId }) =>
        queryClient.invalidateQueries(getQueryKeys.houseHead(houseId)),
    }
  );

  const flats = queryClient.getQueryData(getQueryKeys.flatsGrid(houseId));

  const tenants = useMemo(() => {
    if (flats?.length) {
      return getTenantOptions(flats);
    }

    return [];
  }, [flats]);

  const handleSubmit = (values) => {
    changeHeadOfHouseMutation.mutateAsync({
      houseId,
      values,
      addType: !houseHead?.id,
    });
  };

  return (
    <>
      <HeadOfHouse
        houseHead={houseHead}
        loading={isHouseHeadFetching}
        onChangeButtonClick={showModal}
      />
      <ChangeHeadOfHouseModal
        visible={visible}
        onCancel={hideModal}
        items={tenants}
        initialValue={houseHead?.id}
        onSubmit={handleSubmit}
        confirmLoading={changeHeadOfHouseMutation.isLoading}
      />
    </>
  );
};

export default HouseHead;
